export default __webpack_public_path__ + "static/media/dollar.25a2be75.png";